import React, { useState } from 'react';

const NotepadContent = ({ scenario, onComplete }) => {
  const [content, setContent] = useState('');
  const [fontSize, setFontSize] = useState(14);

  return (
    <div className="h-full flex flex-col bg-white text-black">
      {/* Menu Bar */}
      <div className="flex items-center border-b border-gray-200 bg-gray-50 px-2 py-1">
        <div className="flex items-center space-x-4 text-sm">
          <button className="px-2 py-1 hover:bg-gray-200 rounded">File</button>
          <button className="px-2 py-1 hover:bg-gray-200 rounded">Edit</button>
          <button className="px-2 py-1 hover:bg-gray-200 rounded">Format</button>
          <button className="px-2 py-1 hover:bg-gray-200 rounded">View</button>
          <button className="px-2 py-1 hover:bg-gray-200 rounded">Help</button>
        </div>
        <div className="ml-auto flex items-center space-x-2">
          <label className="text-xs text-gray-600">Font Size:</label>
          <select 
            value={fontSize} 
            onChange={(e) => setFontSize(Number(e.target.value))}
            className="text-xs border border-gray-300 rounded px-1 py-0.5 bg-white"
          >
            <option value={10}>10</option>
            <option value={12}>12</option>
            <option value={14}>14</option>
            <option value={16}>16</option>
            <option value={18}>18</option>
            <option value={20}>20</option>
            <option value={24}>24</option>
          </select>
        </div>
      </div>

      {/* Text Area */}
      <textarea
        value={content}
        onChange={(e) => setContent(e.target.value)}
        className="flex-1 p-4 outline-none resize-none font-mono bg-white"
        style={{ fontSize: `${fontSize}px`, lineHeight: '1.5' }}
        placeholder="Start typing..."
        spellCheck={false}
      />

      {/* Status Bar */}
      <div className="border-t border-gray-200 bg-gray-50 px-3 py-1 flex items-center justify-between text-xs text-gray-600">
        <div>
          {content.length > 0 ? (
            <>
              Lines: {content.split('\n').length} | Characters: {content.length} | Words: {content.trim() ? content.trim().split(/\s+/).length : 0}
            </>
          ) : (
            'Ready'
          )}
        </div>
        <div className="flex items-center space-x-3">
          <span>UTF-8</span>
          <span>Windows (CRLF)</span>
        </div>
      </div>
    </div>
  );
};

export default NotepadContent;

